module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("FROM:")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("DIANE BERG")]), _vm._v(" "), _c('p', {
    staticClass: "exi-bot"
  }, [_vm._v("GENEVA")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("TO:")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("DR WARGNIER")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("WARGNIER PSYCHIATRIC INSTITUTE")]), _vm._v(" "), _c('p', {
    staticClass: "exi-bot"
  }, [_vm._v("SAINT-MARTIN-DE-COMMINGES")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("Diane Berg – Curriculum vitae")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("Psychologist, Swiss Federation of Psychologists (FSP)")]), _vm._v(" "), _c('p', {
    staticClass: "exi-bot"
  }, [_vm._v("Specialist in Forensic Psychology (SSPL)")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("Date of Birth: 16 July 1976")]), _vm._v(" "), _c('p', {
    staticClass: "exi-bot"
  }, [_vm._v("Nationality: Swiss")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("D"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("IPLOMAS")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("2002: Master of advanced studies in clinical psychology (DES), University of Geneva. Dissertation: ‘Instinctual Economy, Necrophilia and Dismembering among Compulsive Killers’.")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("1999: Degree in psychology, University of Geneva. Dissertation: ‘Aspects of Childhood Fear among Children Eight to Twelve Years of Age’.")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("1995: Secondary School Diploma in classical and Latin studies")]), _vm._v(" "), _c('p', {
    staticClass: "exi-bot"
  }, [_vm._v("1994: Cambridge First Certificate in English as a foreign language")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("P"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" E"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("XPERIENCE")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("2003 – present: Private Practice, psychotherapy and forensic psychology, Geneva")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("2001 – present: Assistant to Professor Pierre Spitzner at the Faculty of Psychology and Educational Sciences (FPSE), University of Geneva")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("1999–2001: Intern in psychology, Institute of Forensic Psychology, University of Geneva")]), _vm._v(" "), _c('p', {
    staticClass: "exi-bot"
  }, [_vm._v("Intern in psychology, Medical Services of Champ-Dollon Prison")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("P"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SSOCIATIONS")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("International Academy of Law and Mental Health (IALMH)")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("Geneva Association of Psychologists-Psychotherapists (AGPP)")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("Swiss Federation of Psychologists (FSP)")]), _vm._v(" "), _c('p', {
    staticClass: "exi-bot"
  }, [_vm._v("Swiss Society of Forensic Psychology (SSPL)")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("I"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NTERESTS")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("Classical music (ten years of violin), jazz, reading")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("Sports: swimming, running, diving, potholing, parachute jumping")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ca32ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 72
// module chunks = 0